import { Pipe, PipeTransform } from '@angular/core';
import { TimeFormatUtils } from '../utilities/time-format.utils';

@Pipe({
  name: 'timeFormat',
})
export class TimeFormatPipe implements PipeTransform {
  transform(seconds): any {
    if (Math.floor(seconds / 3600) > 0) {
      const hour = `0${Math.floor(seconds / 3600)}`.slice(-2);
      const min = `0${Math.floor((seconds % 3600) / 60)}`.slice(-2);
      const second = `0${seconds % 60}`.slice(-2);
      return `${hour}:${min}:${second}`;
    } else {
      const min = `0${Math.floor(seconds / 60)}`.slice(-2);
      const second = `0${Math.floor(seconds % 60)}`.slice(-2);
      return `${min}:${second}`;
    }
  }
}

@Pipe({
  name: 'convertTimeFormat',
})
export class ConvertTimeFormatPipe implements PipeTransform {
  /**
   * Converts a time string from any supported format to the specified target format
   * @param timeString - The input time string to convert
   * @param targetFormat - The desired output format (defaults to display format: hh:mm a)
   * @returns The converted time string in the target format
   */
  transform(
    timeString: string,
    targetFormat: string = TimeFormatUtils.DISPLAY_TIME_FORMAT,
  ): string {
    return TimeFormatUtils.convertTimeFormat(timeString, targetFormat);
  }
}
